// Vendor
// Actions
import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllAccounts, removeAccounts, resetAccountResultsLoaded, resetSelectedAccounts, selectAccount, setAccountResultsLoaded, setPortfolioImportType, } from './actions';
// Constants
import { MODEL_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const portfolioImportType = createReducer(MODEL_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => newPortfolioImportType));
export const selectedAccounts = createReducer([], on(selectAccount, (state, { selectedAccount: newAccount }) => {
    if (state.some((a) => a.id === newAccount.id)) {
        return state.filter((a) => a.id !== newAccount.id);
    }
    return [...state, newAccount];
}), on(addAllAccounts, (state, { accounts }) => {
    const existingIds = new Set(state.map((a) => a.id));
    const additions = accounts.filter((a) => !existingIds.has(a.id)).map((a) => ({ id: a.id, name: a.name }));
    return [...state, ...additions];
}), on(removeAccounts, (state, { accountIds }) => {
    const toRemove = new Set(accountIds);
    return state.filter((a) => !toRemove.has(a.id));
}), on(resetSelectedAccounts, () => []));
export const accountResultsLoaded = createReducer(false, on(setAccountResultsLoaded, (state, { loaded }) => loaded), on(resetAccountResultsLoaded, () => false));
export const fidelityImportHoldings = combineReducers({
    portfolioImportType,
    selectedAccounts,
    accountResultsLoaded,
});
